export default "__VITE_PUBLIC_ASSET__e22ffaff__"